import { Link } from 'gatsby';
import styled from 'styled-components';

export const OuterContainer = styled.div`
  ${(props) => props.theme.breakpoints.down('md')} {
    padding: 0;
    width: 100%;
  }
  margin: 0 0 20px 0;
  ${({ theme }) => theme.breakpoints.down('sm')} {
    margin: 0;
  }
  .MuiFormLabel-root {
    color: ${(props) => props.theme.palette.primary.contrastText};
  }

  .MuiSwitch-root {
    & .MuiSwitch-switchBase {
      &.Mui-checked {
        & + .MuiSwitch-track {
          background-color: ${({ theme }) => theme.palette.grey['400']};
        }
      }
    }
  }
`;

export const HeaderContainer = styled.div<{ showBackground: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
  ${(props) =>
    props.showBackground
      ? `background: linear-gradient(
    90deg,
    ${props.theme.palette.primary.light} 0%,
    ${props.theme.palette.primary.dark} 100%
  );`
      : ''}

  padding: 0;
  text-align: left;
  color: white;
`;

export const TitleDiv = styled.div`
  width: 100%;
  font-size: 44px;
  color: ${({ theme }) => theme.palette.primary.contrastText};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-transform: capitalize;
`;

export const HeaderContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const AdditionalInfo = styled.div`
  width: 100%;
  padding: 10px 0 0 0;
  box-sizing: border-box;

  ${(props) => props.theme.breakpoints.down('sm')} {
    flex-direction: column;
    align-items: flex-start;
    padding: 0px 20px;
  }
`;

export const Item = styled.div`
  white-space: wrap;
  display: inline-block;
  margin-right: 30px;

  &:last-child {
    margin-right: 0;
  }
`;

export const ItemTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ItemTitle = styled.div<{
  color?: string;
}>`
  font-size: 16px;
  font-weight: bold;
  padding-top: 5px;
  color: ${(props) =>
    props.color ? props.color : props.theme.palette.primary.contrastText};
`;

export const ItemIcon = styled.div`
  font-size: 20px;
  flex-direction: flex-start;
  margin-right: 8px;
  width: 20px;
  text-align: center;
`;

export const BackButton = styled.div`
  position: absolute;
  top: 6px;
  left: -74px;
`;

export const TitleWidth = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;

  ${(props) => props.theme.breakpoints.down('sm')} {
    padding: 10px 20px;
  }
`;

export const ChildDiv = styled.div`
  width: 100%;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.palette.primary.contrastText};
  font-size: 44px;
  font-weight: bold;
  line-height: 58px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  white-space: wrap;

  ${(props) => props.theme.breakpoints.down('md')} {
    font-size: 36px;
    line-height: 44px;
  }
  ${(props) => props.theme.breakpoints.down('sm')} {
    font-size: 24px;
    line-height: 30px;
    padding-left: 20px;
  }
`;

export const Subtitle = styled.div<{ subtitleSize: string }>`
  font-size: ${(props) => props.subtitleSize};
  font-weight: 600;
  color: ${({ theme }) => theme.palette.primary.contrastText}88;

  ${(props) => props.theme.breakpoints.down('sm')} {
    box-sizing: border-box;
    padding-left: 20px;
    margin-bottom: 10px;
    width: 100%;
  }
`;

export const MobileBackButton = styled(Link)`
  height: 23px;
  width: 189px;
  opacity: 0.7;
  color: ${({ theme }) => theme.palette.primary.contrastText};
  font-size: 16px;
  line-height: 25px;
  font-weight: 300;

  display: flex;
  align-items: center;

  &:hover {
    opacity: 1;
    color: ${({ theme }) => theme.palette.primary.contrastText};
  }
`;

export const IconDiv = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  width: 50px;
`;
